import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Config from "../../config";
import User from "../../../../services/user";
import Session from "../../utils/session";
import Page from "../../../../services/page-data-feed";
import MobilePage from "../../utils/mobile-page";

import formatCurrency from "../../../../services/currency";

import { UserIcon, CloseIconSlim, HelpIcon } from "../../mobile-templates/general";
import { BonusIcon, UpArrowIcon } from "../../utils/icons";

import AwrabetMenuRight, {
	SlidingContainer as AwrabetSlidingContainer,
	GuestUserMenu as AwrabetGuestUserMenu,
	LoggedUserMenu as AwrabetLoggedUserMenu
} from "../../../awrabet/mobile-components/site/menu-right";

export class SlidingContainer extends AwrabetSlidingContainer {
	componentWillMount() {
		MobilePage.addOnRightMenuChange(this.listener = (e => this.setState({})));
	}
	componentDidUnmount() {
		MobilePage.removeOnRightMenuChange(this.listener);
	}
	render({ children }) {
		return <div
			id="right-menu"
			class={"fixed z-10 -right-full top-0 bottom-0 w-full bg-black/70 pl-12 transition-all " + (MobilePage.isRightMenuOpen() ? "-translate-x-full" : "")}
			onClick={(e) => {
				if (e.target != e.currentTarget)
					return;
				MobilePage.closeRightMenu();
			}}
		>
			{children}
		</div>;
	}
}

export default class MenuRight extends AwrabetMenuRight {
	render() {
		return (
			<SlidingContainer>
				<div class="absolute top-0 left-0 w-12 p-1 pt-2 text-white" onClick={(e) => { MobilePage.closeRightMenu(); }}>
					<CloseIconSlim />
				</div>

				{User.isLogged() ? <LoggedUserMenu /> : <GuestUserMenu />}
			</SlidingContainer>
		);
	}
}

export class GuestUserMenu extends AwrabetGuestUserMenu {
	render() {
		return (
			<div id="guest-user-buttons" class="h-full w-full max-w-sm border-l border-black bg-harif-800 text-white">
				<div class="pt-2">
					<div class="p-2 px-2">
						<div class="pb-1 text-center">
							<Trans>Already have an account?</Trans>
						</div>
						<a class="mx-auto w-40 bg-custom-oraborder-custom-orange-dark text-black py-2 text-center text-sm uppercase block rounded" href="#login">
							<Trans>Login</Trans>
						</a>
					</div>
					<div class="p-2 px-2">
						<div class="pb-1 text-center">
							<Trans>Don't have an account</Trans>
						</div>
						<a class="mx-auto w-40 bg-custom-oraborder-custom-orange-dark text-black py-2 text-center text-sm uppercase block rounded" href="#register">
							<Trans>Register</Trans>
						</a>
					</div>
				</div>
				<div class="bg-harif-800 py-2 hidden">
					<div class="flex items-center justify-center gap-1 p-2 px-2">
						<div class="w-8">
							<HelpIcon class="w-full" />
						</div>
						<div class="pb-1 text-center"><Trans>Need Help?</Trans></div>
					</div>
					<div class="mx-auto w-40 border border-brand-900 bg-harif-800 py-2 text-center text-sm uppercase"><Trans>Live Chat</Trans></div>
				</div>
			</div>
		);
	}
}

export function WalletsPanel({ balance, payable, bonus }) {
	return <div class="text-sm w-full px-2 border-l border-harif-850 leading-none mt-1">
		<div class="w-full grid grid-cols-[70px_1fr]">
			<span class="inline-block w-20 text-sm font-bold uppercase"><Trans>Balance</Trans>:</span> <span class="font-bold text-sm">{balance} {Config.currencySymbol}</span>
			<span class="inline-block w-20 text-xs font-bold uppercase"><Trans>Payable</Trans>:</span> <span class="font-bold text-xs">{payable} {Config.currencySymbol}</span>
			{/*<WalletsRow><span><BonusIcon class="h-3 inline-block relative -top-px" /> <Trans>Bonus</Trans></span> <span class="font-mono">{bonus}</span></WalletsRow>*/}
		</div>
	</div>
}

export function WalletsRow({ children, ...props }) {
	return <div class={"flex justify-start items-center " + props['class']}>{children}</div>
}

export class LoggedUserMenu extends AwrabetLoggedUserMenu {
	render() {
		return (
			<div id="logged-user-buttons" class="flex h-full w-full max-w-sm ml-auto flex-col border-l border-black bg-harif-800 text-white">
				<div class="flex flex-col gap-2 bg-custom-orange text-black p-2">
					<div class="flex grow">
						<div class="aspect-square h-11 p-1">
							<UserIcon />
						</div>
						<div class="flex flex-col justify-center w-full">
							<div class="text-xs">{User.username()}</div>
							<div class="text-xs font-bold">ID: {User.accountId()}</div>
							<WalletsPanel
								balance={formatCurrency(User.balance())}
								payable={formatCurrency(User.payable())}
								bonus={formatCurrency(User.bonus())}
							/>
						</div>
					</div>
					<div class="bg-harif-800 text-white py-1 text-xs uppercase w-full px-2 flex justify-between">
						<div>
							<span class="inline-block uppercase pr-3"><Trans>Bonus</Trans>:</span>
							<span>{User.bonus()} {Config.currencySymbol}</span>
						</div>
						<a href="/user/bonus-states" class="block" onClick={() => this.closeMenu()}>
							<span class="inline-block uppercase pr-2"><Trans>My Bonuses</Trans>:</span>
							<span class="border-l border-white inline-block pl-0.5"><UpArrowIcon class="rotate-90 h-4 inline-block relative bottom-px" /></span>
						</a>
					</div>
					<div class="flex gap-2 w-full">
						<a class="rounded bg-harif-800 text-white py-1 text-center text-sm uppercase w-full" href="/user/payment-gateway/deposit" onClick={() => this.closeMenu()}>
							<Trans>Deposit</Trans>
						</a>
						<a class="rounded bg-harif-800 text-white py-1 text-center text-sm uppercase w-full" href="/user/payment-gateway/withdraw" onClick={() => this.closeMenu()}>
							<Trans>Withdraw</Trans>
						</a>
					</div>
				</div>
				<div class="min-h-0 grow overflow-y-auto">
					<div onClick={e => MobilePage.closeRightMenu()}>
						<a href="/user" class="flex h-10 items-center bg-harif-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Account</Trans>
							</span>
						</a>
						<a href="/user/password" class="flex h-10 items-center bg-harif-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Change Passowrd</Trans>
							</span>
						</a>
						<div class="border-b border-custom-orange-dark w-full"></div>
						<a href="/user/payment-gateway/deposit" class="flex h-12 items-center bg-harif-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Deposit</Trans>
							</span>
						</a>
						<a href="/user/payment-gateway/withdraw" class="flex h-12 items-center bg-harif-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Withdraw</Trans>
							</span>
						</a>
						<a href="/user/vouchers" class="flex h-12 items-center bg-harif-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Vouchers</Trans>
							</span>
						</a>
						<div class="border-b border-custom-orange-dark w-full"></div>
						<a href="/user/tickets" class="flex h-12 items-center bg-harif-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>All Bets History</Trans>
							</span>
						</a>
						<a href="/user/transactions" class="flex h-10 items-center bg-harif-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Account History</Trans>
							</span>
						</a>
						<div class="border-b border-custom-orange-dark w-full"></div>
						<a href="/contacts" class="flex h-12 items-center bg-harif-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Help Page</Trans>
							</span>
						</a>
						{!!Session.fetch('club') && !Session.fetch('manager') && <a href="/manager/dashboard" onClick={() => this.closeMenu()} class="flex h-12 items-center bg-harif-800 px-2 uppercase text-white">
							<span class="px-2">
								<Trans>Players</Trans>
							</span>
						</a>}
						<div class="flex h-12 items-center bg-harif-800 px-2 uppercase text-white fn-logout-btn" onClick={e => { Session.logoutPromise().finally(e => Page.rerender()) }}>
							<span class="px-2">
								<Trans>Logout</Trans>
							</span>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
